import { Box, Button, IconButton, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import { FONTS } from "../utils/fontConstant";
import { Modal } from "../packages";
import { WHITE } from "../theme/colors";
import styles from "./upgradeModal.module.scss";
import { useAppDispatch } from "../redux/store";
import { subscribeMiddleWare } from "../modules/SignUpModule/store/signupMiddleware";
import { analyticsEvent } from "../utils/analyticsHelper";
import { ANALYTICS_EVENT } from "../utils/analyticsConstants";
import { currencyConvertedSymbol, handleBlockPopUp } from "../utils/helpers";
import { getUserMiddleWare } from "../modules/ProfileModule/store/profileMiddleware";
import { useState } from "react";
import PaymentProgrees from "../modules/BillingModule/PaymentProgrees";
import { GetSubscriptionsAllPlans } from "../modules/BillingModule/store/billing.types";
import MembershipInclusion from "./MembershipInclusion";

type Props = {
  close: () => void;
  open: boolean;
  title: string;
  data: GetSubscriptionsAllPlans;
  showCloseButton?: boolean; // Add a new prop to control the visibility of the close button
};

const UpgradeModal = ({
  close,
  open,
  title,
  data,
  showCloseButton = true,
}: Props) => {
  const dispatch = useAppDispatch();
  const [isPayment, setPayment] = useState(false);

  const handleStripePayment = () => {
    const payload = {}; // Add any required payload here if needed
    dispatch(subscribeMiddleWare({ payload })).then((res) => {
      if (res.payload) {
        analyticsEvent({
          eventName: ANALYTICS_EVENT.BILLING_SUBSCRIPTION_SUCCESS,
          parameters: {
            platform: "stripe",
            iapResponse: res.payload,
          },
        });
        handleBlockPopUp(
          res.payload.stripeCheckoutSessionURL,
          () => {
            dispatch(getUserMiddleWare());
            setPayment(true);
          },
          () => {}
        );
      } else {
        analyticsEvent({
          eventName: ANALYTICS_EVENT.BILLING_SUBSCRIPTION_ERROR,
          parameters: {
            platform: "stripe",
            message: res.payload?.response?.data?.message,
          },
        });
      }
    });
  };

  return (
    <Modal cardClassName="upgradeModal" open={open} close={() => {}}>
      <PaymentProgrees
        open={isPayment}
        close={() => setPayment(false)}
        isNewUser={false}
      />
      <Box className={styles.overAll}>
        <Box className={styles.leftSide}>
          <img
            alt="Upgrade"
            className={styles.imageBg}
            src={require("../images/upgradeModal_bg.webp")}
          />
          <div className={styles.upgradeInclusionList}>
            <MembershipInclusion />
          </div>
        </Box>
        <Box className={styles.rightBox}>
          {showCloseButton && ( // Conditionally render the close button
            <IconButton className={styles.closeModal} onClick={close}>
              <Close />
            </IconButton>
          )}
          <h2 className={styles.title}>We’ve Made Some Changes</h2>
          <p className={styles.text}>
            Testosteronology is now a paid experience to ensure premium quality
            for all users.
          </p>
          <a
            className={styles.link}
            href="https://www.testosteronology.com"
            target="_blank"
          >
            See what's included
          </a>
          <div className={styles.price}>
            <p>Enjoy full access for just</p>
            <h2>
              {currencyConvertedSymbol(data?.paid?.CURRENCY)}
              {data?.paid?.PRICE} <sub>/ month</sub>
            </h2>
          </div>
          <Button
            className={styles.upgradeButton}
            size="large"
            sx={{ textTransform: "capitalize" }}
            variant="contained"
            onClick={() => handleStripePayment()}
          >
            Upgrade Now
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default UpgradeModal;
